import { defineComponent as a, computed as i } from "vue";
const u = /* @__PURE__ */ a({
  __name: "price",
  props: {
    amount: null,
    isHighlight: { type: Boolean },
    isPriceBold: { type: Boolean },
    isWasPrice: { type: Boolean },
    preText: { default: void 0 },
    postText: { default: void 0 },
    theme: { default: void 0 },
    variant: { default: void 0 }
  },
  setup(h, { expose: p }) {
    const e = h, s = i(() => {
      const t = [];
      return e.theme && t.push(`price--${e.theme}`), e.variant && t.push(`price--variant-${e.variant}`), t;
    }), r = i(() => {
      const t = [];
      return e.theme && t.push(`price__amount--${e.theme}`), e.isHighlight && t.push("price__pre-text--highlight"), t;
    }), o = i(() => {
      const t = [];
      return e.theme && t.push(`price__amount--${e.theme}`), e.isWasPrice && e.theme === "light" ? t.push("text--strikethrough") : e.isWasPrice && t.push("text--strikethrough-primary"), e.isHighlight && t.push("price__amount--highlight"), e.isPriceBold && t.push("text--bold"), t;
    });
    return p({ priceClasses: o, classes: s, preTextClasses: r }), { __sfc: !0, props: e, classes: s, preTextClasses: r, priceClasses: o };
  }
});
export {
  u as default
};
